import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState('usd');
  const currencies = ['usd', 'chf', 'gbp'];
  const [updateCount, setUpdateCount] = useState(0);

  const fetchPrice = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=${selectedCurrency}&include_24hr_change=true`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.bitcoin || !data.bitcoin[selectedCurrency]) {
        throw new Error('Invalid response format');
      }

      setPrice(data.bitcoin[selectedCurrency]);
      setUpdateCount(prev => prev + 1);
    } catch (err) {
      setError(`Failed to fetch Bitcoin price: ${err.message}`);
      setPrice(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrice();
  }, [selectedCurrency]);

  const formatPrice = (price) => {
    return price.toLocaleString(undefined, {
      style: 'currency',
      currency: selectedCurrency.toUpperCase(),
    });
  };

  return (
    <div className="container">
      <div className="currency-selector">
        <select
          value={selectedCurrency}
          onChange={(e) => setSelectedCurrency(e.target.value)}
          className="dropdown"
        >
          {currencies.map((currency) => (
            <option key={currency} value={currency}>
              {currency.toUpperCase()}
            </option>
          ))}
        </select>
      </div>

      <div className="price-container">
        {loading ? (
          <div className="loading">
            <div className="skeleton"></div>
          </div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : (
          <>
            <h1 className="price">
              {formatPrice(price)}
            </h1>
            <button
              onClick={fetchPrice}
              className="refresh-button"
              disabled={loading}
            >
              {loading ? (
                <div className="loading-spinner"></div>
              ) : (
                'Update Price'
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default App;